import React, { useState } from "react";
import Heading from "../../elements/heading";
import PrimaryButton from "../../elements/primary-button";
import InputPhoneNumber from "../../elements/InputPhoneNumber";
import Modal from "../../components/Modal";
import BodyText from "../../elements/body-text";
import "./style.scss";
import { useDispatch, useSelector } from "react-redux";
import { setUserInfoAction } from "../../redux/actions";
import { selectUserState } from "../../selectors/application";
import { isEmptyScObj } from "../../utils/siteUtils";

function FillPhoneNumberModal(props) {
  if (isEmptyScObj(props)) {
    return null;
  } else {
    return <FillPhoneNumberModalMain {...props} />;
  }
}
function FillPhoneNumberModalMain({ fields, open, onCloseClicked, onFilled }) {
  /*Redux start*/
  const dispatch = useDispatch();
  const user = useSelector(selectUserState);
  const setUserInfo = payload => setUserInfoAction(payload);
  /*Redux end*/
  const { phoneMissingMessage, phoneWarningMessage, countryCodeLabel, cta, description, headingBody, headingType, phoneNumberLabel, phoneAreaLabel, phoneNumberInfoText, title } = fields;
  const [phoneArea, setPhoneArea] = useState(null);
  const [phone, setPhone] = useState(null);
  const [phoneIsValid, setPhoneIsValid] = useState(false);
  const [submitTimestamp, setSubmitTimestamp] = useState();
  const onSubmit = async evt => {
    setSubmitTimestamp(new Date());
    evt.preventDefault();
    if (!phoneIsValid) {
      return;
    }

    onFilled &&
      onFilled({
        phone,
        phoneArea
      });
    // try {
    //   await api.user.update(null, {
    //     ...user,
    //     mobileNoCountryCode: formDataPhoneArea,
    //     mobileNo: formDataPhone
    //   });
    //   const userNew = await getUserInfo();
    //   setUserInfo(userNew);
    //   onUpdateSuccess(userNew);
    // } catch (ex) {
    //   console.log(ex);
    //   switch (ex.code) {
    //     case "USER_CUSTOMER_026":
    //       setPhoneHasError(true);
    //       setPhoneHasValidationError(true);
    //       break;
    //     default:
    //   }
    // }
  };
  const modalProps = {
    showModal: open,
    onCloseClicked: evt => {
      onCloseClicked && onCloseClicked(evt);
    }
  };

  const onPhoneChange = (area, number, isValid) => {
    setPhoneArea(area);
    setPhone(number);
    setPhoneIsValid(isValid);
  };

  return (
    <Modal className="change-phone-setting-modal" {...modalProps}>
      {/* Enter password step */}
      <React.Fragment>
        <Heading type={headingType} html={headingBody} className="change-phone-number-modal-heading" typographyClass="type-h1" />

        <Heading type={{ fields: { phrase: { value: "h3" } } }} html={title} typographyClass="type-h3" className="change-phone-number-modal-sub-heading" />

        <BodyText html={description?.value} className="change-phone-number-modal-body" />
        {countryCodeLabel?.value && phoneNumberLabel?.value && (
          <div className="change-phone-number-modal-input">
            <InputPhoneNumber
              phoneArea={{
                label: phoneAreaLabel.value,
                value: phoneArea
              }}
              phoneNumber={{
                label: phoneNumberLabel.value,
                value: phone
              }}
              infoMessage={phoneNumberInfoText?.value}
              warningMessage={phoneWarningMessage}
              missingMessage={phoneMissingMessage}
              onChange={(area, number, isValid) => {
                onPhoneChange(area, number, isValid);
              }}
              onInit={(area, number, isValid) => {
                onPhoneChange(area, number, isValid);
              }}
              submitTimestamp={submitTimestamp}
            />
          </div>
        )}
        {/*{accountExists && accountExistsMessage && <span className="failed-message">{accountExistsMessage.value}</span>}*/}
        {/*{phoneExists && phoneExixtsMessage && <span className="failed-message">{phoneExixtsMessage.value}</span>}*/}
        <div className="change-phone-number-modal-button">
          <PrimaryButton
            {...{
              ...cta?.fields,
              buttonText: cta?.fields?.buttonText?.value,
              callback: evt => onSubmit(evt)
            }}
          />
        </div>

        {/*{disclaimerPassword.value && (*/}
        {/*  <div className="change-phone-number-modal-disclaimer">*/}
        {/*    <BodyText html={disclaimerPassword.value} className="disclaimer" />*/}
        {/*  </div>*/}
        {/*)}*/}
      </React.Fragment>
    </Modal>
  );
}
export default FillPhoneNumberModal;
